import { TABS, type TabKey } from 'talent_matching/contexts/user_context';

type TabDefinition = {
  key: TabKey;
  segment: string;
  label: string;
};

/**
 * The tabs, in rendered order. The first tab owns the base path and so has an
 * empty segment; every other tab is the base path plus its segment.
 *
 * Retired tabs are redirected to the base path server-side (see the concept's
 * `config/routes.rb`), so an unrecognized trailing segment never reaches here.
 * Anything unmatched still resolves to the first tab rather than to no tab.
 */
export const ALL_TABS: readonly TabDefinition[] = [
  { key: TABS.APP_REVIEW, segment: '', label: 'tabs.app_review' },
  { key: TABS.REDISCOVERY, segment: '/rediscovery', label: 'tabs.rediscovery' },
];

const matchedTabIndex = (pathname: string) =>
  ALL_TABS.findIndex(
    (tab) => tab.segment !== '' && pathname.endsWith(tab.segment)
  );

export const getTabIndexFromUrl = (pathname: string): number => {
  const index = matchedTabIndex(pathname);

  return index === -1 ? 0 : index;
};

export const getBasePath = (pathname: string): string => {
  const index = matchedTabIndex(pathname);

  return index === -1
    ? pathname
    : pathname.slice(0, -ALL_TABS[index].segment.length);
};

export const getTabPath = (pathname: string, tabIndex: number): string =>
  `${getBasePath(pathname)}${ALL_TABS[tabIndex].segment}`;
